import {Component, Renderer2} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {LoaderService} from '@services/loader.service';
import {SupplierService} from '@services/supplier.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-add-supplier',
    templateUrl: './add-supplier.component.html',
    styleUrl: './add-supplier.component.scss'
})
export class AddSupplierComponent {
    public supplierForm: FormGroup;
    public cities: any = [];
    public birdTypes: any = [];
    public breeds: any = [];
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    public errorMessage: string = '';
    constructor(
        private renderer: Renderer2,
        private toastr: ToastrService,
        private fb: FormBuilder,
        private supplierService: SupplierService,
        private loaderService: LoaderService
    ) {
        this.isLoading$ = this.loaderService.isLoading$;
    }
    ngOnInit() {
        this.supplierForm = this.fb.group({
            name: ['', [Validators.required, this.onlyLettersValidator()]],
            phone: [
                '',
                [Validators.required, Validators.pattern('^[0-9]{10}$')]
            ],
            email: [
                '',
                [
                    Validators.required,
                    Validators.pattern(
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
                    )
                ]
            ],
            countrycode: ['', [Validators.required]],
            cityid: ['', [Validators.required]],
            birdstypeid: ['', [Validators.required]],
            breedid: ['', [Validators.required]],
            code: ['', [Validators.required]]
        });
        //load default selection value
        this.getAllCities();
        this.getAllBirdType();
        this.getAllBreed();
    }
    //validation of fields
    onlyLettersValidator() {
        return (control) => {
            const nameRegex = /^[a-zA-Z ]*$/; // Regular expression to allow only letters and spaces
            const valid = nameRegex.test(control.value);
            return valid ? null : {onlyLetters: true};
        };
    }

    addSupplier() {
        this.markFormGroupTouched(this.supplierForm);
        if (this.supplierForm.valid) {
            this.loaderService.showLoader();
            this.isAuthLoading = true;
            this.supplierService
                .createSupplier(this.supplierForm.value)
                .subscribe({
                    next: (response: any) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            this.toastr.success('Supplier Added Successfully');
                        }, 2000);
                    },
                    error: (error) => {
                        console.error('Error occurred:', error);
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            // Handle login error
                            this.toastr.error(error.error.error);
                        }, 2000);
                    }
                });
        }
    }
    getAllCities() {
        this.supplierService.getCityList().subscribe((result) => {
            this.cities = result;
        });
    }
    getAllBirdType() {
        this.supplierService.getBirdTypeList().subscribe((result) => {
            this.birdTypes = result;
        });
    }
    getAllBreed() {
        this.supplierService.getBreedList().subscribe((result) => {
            this.breeds = result;
        });
    }
    private markFormGroupTouched(formGroup: FormGroup) {
        Object.values(formGroup.controls).forEach((control) => {
            control.markAsTouched();

            if (control instanceof FormGroup) {
                this.markFormGroupTouched(control);
            }
        });
    }
    generateCode() {
        const code = this.generateRandomCode();
        this.supplierForm.patchValue({code: code});
    }
    private generateRandomCode(): string {
        // Implement your logic to generate a random 6-letter code
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let code = '';
        for (let i = 0; i < 6; i++) {
            code += characters.charAt(
                Math.floor(Math.random() * characters.length)
            );
        }
        return code;
    }
}
